import React from 'react';
import { TbClipboardText } from 'react-icons/tb';
import { Tab } from '../../../../components';
import MeasureOptions from './MeasureOptions';
import { TabItem } from '../../../../@types/types';

const TapeMeasure: React.FC = () => {
    const items: TabItem[] = [
        {
            icon: (<TbClipboardText/>),
            content: (<MeasureOptions/>),
            title: 'Measure Options',
            is_active: true,
        }
    ];

    return ( <Tab items={items}/> );
}

export default TapeMeasure;